<!-- src/components/OptionComponent.vue -->
<script setup lang="ts">
import { inject } from 'vue';

const props = defineProps<{
  label: string;
  value: string | number;
}>();

// we’ll inject a function called “selectFn” from the parent SelectComponent
const selectFn = inject<(v: string | number) => void>('selectFn')!;

function onClick() {
  selectFn(props.value);
}
</script>

<template>
  <div
    class="flex items-center pl-8 px-2 py-1 cursor-pointer hover:text-sybil-teal hover:bg-sybil-light-teal-2 text-xs"
    @click.stop="onClick"
  >
    {{ label }}
  </div>
</template>
